import { Vue } from 'vue-property-decorator';
import axios from 'axios';

axios.defaults.headers.post['Access-Control-Allow-Origin'] = '*';

export const Tasklist = {
  namespaced: true,

  state: {
    viewList: [],
    pendingSidebarTasks: [],
    completedSidebarTasks: [],
    loaded: {}, // keys can be project or repository uuids
    pagination: {}, // keys can be project or repository uuids
  },

  getters: {
    viewTaskList: ({ viewList }) => viewList,

    pendingSidebarTaskList: ({ pendingSidebarTasks }) => pendingSidebarTasks,

    completedSidebarTaskList: ({ completedSidebarTasks }) => completedSidebarTasks,

    isTasklistLoaded: (state) => (projectOrRepository) => state.loaded[projectOrRepository],

    getCurrentPagination: (state) => (projectOrRepository) => state.pagination[projectOrRepository],
  },

  mutations: {
    setViewList(state, list) {
      state.viewList = list;
    },

    setPendingSidebarTasks(state, list) {
      state.pendingSidebarTasks = list;
    },

    setCompletedSidebarTasks(state, list) {
      state.completedSidebarTasks = list;
    },

    setLoaded(state, payload) {
      state.loaded = { ...state.loaded, ...payload };
    },

    setPagination(state, payload) {
      Vue.set(state.pagination, Object.keys(payload)[0], Object.values(payload)[0]);
    },

    resetSidebarTaskLists(state) {
      Vue.set(state, 'pendingSidebarTasks', []);
      Vue.set(state, 'completedSidebarTasks', []);
    },

    removePendingSidebarTask(state, id) {
      Vue.delete(
        state.pendingSidebarTasks,
        state.pendingSidebarTasks.findIndex((t) => t.id === id)
      );
    },
  },

  actions: {
    async loadViewList({ commit }, { project, page, perPage, filter }) {
      let list = [];
      let pagination = {};
      const { repository } = filter;
      commit('setLoaded', { [project ?? repository]: false });
      try {
        const response = await this._vm.$api('tasks.get', {
          version: '1.0',
          perPage,
          filter,
          page,
        });
        list = response.data.data;
        pagination = { ...response.data.meta, ...response.data.link };
        commit('setLoaded', { [project ?? repository]: true });
      } catch (err) {
        console.error(err);
        commit('setLoaded', { [project ?? repository]: true });
      }
      commit('setPagination', { [project ?? repository]: pagination });
      commit('setViewList', list);
    },

    removeViewTasklist({ commit }, projectOrRepository) {
      commit('setViewList', []);
      commit('setLoaded', { [projectOrRepository]: false });
    },

    loadSidebarPendingList({ state, commit }, { filter, page }) {
      return new Promise((resolve, reject) => {
        if (!page) {
          commit('setPendingSidebarTasks', []);
        }
        this._vm
          .$api('tasks.get', {
            version: '1.0',
            perPage: 12,
            filter,
            page,
          })
          .then((response) => {
            if (!page) {
              commit('setPendingSidebarTasks', response.data.data);
            } else {
              commit('setPendingSidebarTasks', [...state.pendingSidebarTasks, ...response.data.data]);
            }
            resolve({ hasNext: response.data.meta.current_page < response.data.meta.last_page });
          })
          .catch((err) => {
            console.error(err);
            reject(err);
          });
      });
    },

    loadSidebarCompletedList({ state, commit }, { filter, page }) {
      return new Promise((resolve, reject) => {
        if (!page) {
          commit('setCompletedSidebarTasks', []);
        }
        this._vm
          .$api('tasks.get', {
            version: '1.0',
            perPage: 8,
            filter,
            page,
          })
          .then((response) => {
            if (!page) {
              commit('setCompletedSidebarTasks', response.data.data);
            } else {
              commit('setCompletedSidebarTasks', [...state.completedSidebarTasks, ...response.data.data]);
            }
            resolve({ hasNext: response.data.meta.current_page < response.data.meta.last_page });
          })
          .catch((err) => {
            console.error(err);
            reject(err);
          });
      });
    },

    resetSidebarLists({ commit }) {
      commit('resetSidebarTaskLists');
    },

    removePendingSidebarTask({ commit }, { id }) {
      commit('removePendingSidebarTask', id);
    },
  },
};
